<template>
  <div class="included-services">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>Your included <strong>services</strong></h1>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-6 col-12 mb-4">
          <div class="service">
<!--            <div><img src="/images/service-tyres.jpg" alt="Tyres" class="mb-2"></div>-->
            <h2>{{product.included_services_service_one}}</h2>
            <p>
              {{product.included_services_service_one_description}}
            </p>
            <div class="phone"><a><b>{{product.included_services_service_one_contact_number}}</b></a></div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 col-12 mb-4">
          <div class="service">
            <!--<div><img src="/images/service-breakdown.jpg" alt="Breakdown" class="mb-2"></div>-->
            <h2>{{product.included_services_service_two}}</h2>
            <p>
              {{product.included_services_service_two_description}}
            </p>
            <div class="phone"><a><b>{{product.included_services_service_two_contact_number}}</b></a></div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 col-12 mb-4">
          <div class="service">
            <!--<div><img src="/images/service-maintenance.jpg" alt="Maintenance" class="mb-2"></div>-->
            <h2>{{product.included_services_service_three}}</h2>
            <p>
              {{product.included_services_service_three_description}}
            </p>
            <div class="phone"><a><b>{{product.included_services_service_three_contact_number}}</b></a></div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 col-12 mb-4">
          <div class="service">
            <!--<div><img src="/images/service-insurance.jpg" alt="Insurance" class="mb-2"></div>-->
            <h2>{{product.included_services_service_four}}</h2>
            <p>
              {{product.included_services_service_four_description}}
            </p>
            <div class="phone"><a><b>{{product.included_services_service_four_contact_number}}</b></a></div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 col-12 mb-4">
          <div class="service">
            <!--<div><img src="/images/service-windscreen.jpg" alt="Windscreen" class="mb-2"></div>-->
            <h2>{{product.included_services_service_five}}</h2>
            <p>
              {{product.included_services_service_five_description}}
            </p>
            <div class="phone"><a><b>{{product.included_services_service_five_contact_number}}</b></a></div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 col-12 mb-4">
          <div class="service">
<!--            <div><img src="/images/service-accident.jpg" alt="Accident" class="mb-2"></div>-->
            <h2>{{product.included_services_service_six}}</h2>
            <p>
              {{product.included_services_service_six_description}}
            </p>
            <div class="phone"><a><b>{{product.included_services_service_six_contact_number}}</b></a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vehicle-services",
  props: {
    product: Object
  },
};
</script>

<style scoped lang="scss">
.included-services {
  padding: 4rem 0;
}

</style>
